require('./payrollLoanLayoutWizard.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');
// @ helpers
const { formatText } = require('core/i18n').i18n;
const { toFirstUppercase } = require('utilities/stringHelper');
const { recordProcess, PROC_START, PROC_CANCEL } = require('utilities/tagging');
// @ components
const PayrollLoanCalculationCard = require('../../contractPayrollLoan/payrollLoanCalculationCard/payrollLoanCalculationCard');
const PreLeaveModalComponent = require('components/preLeaveModalComponent/preLeaveModalComponent');
const { OKButton } = require('components/commons/OKButton/OKButton');

class PayrollLoanLayoutWizard extends React.Component {

    constructor(props) {
        super(props);

        this.handleCancelClick = this.handleCancelClick.bind(this);
    }

    componentDidMount() {
        recordProcess(this.props.processType, PROC_START);
    }

    getCancelButton() {
        const { cancelButtonText } = this.props;
        const buttonText = cancelButtonText ? cancelButtonText : formatText('buttonsActions-cancel');
        const finalButtonText = toFirstUppercase(buttonText);

        return (
            <div className="wizard-step__first-button">
                <OKButton
                    modifier="link-ghost"
                    onClick={this.handleCancelClick}
                >
                    {finalButtonText}
                </OKButton>
            </div>
        );
    }

    getGoBackButton() {
        const backText = toFirstUppercase(formatText('buttonsActions-goBack'));
        return (
            <div className="wizard-step__first-button">
                <OKButton
                    modifier="link-ghost"
                    onClick={this.props.actions.handlePrevClick}
                >
                    {backText}
                </OKButton>
            </div>
        );
    }

    getNextButton() {
        const { isLoading, nextButtonDisabled } = this.props;
        const buttonText = toFirstUppercase(formatText('buttonsActions-next'));
        const CurrentButton = OKButton;

        return (
            <div className="wizard-step__third-button">
                <CurrentButton
                    modifier="secondary"
                    rightIcon="icon-siguiente"
                    onClick={this.props.actions.handleNextClick}
                    loading={isLoading}
                    disabled={nextButtonDisabled}
                >
                    {buttonText}
                </CurrentButton>
            </div>
        );
    }

    getPreviousButton() {
        const buttonText = toFirstUppercase(formatText('buttonsActions-previous'));
        const { actions: { handlePrevClick } } = this.props;
        let onClick = handlePrevClick;

        return (
            <div className="wizard-step__second-button">
                <OKButton modifier="ghost" leftIcon="icon-anterior" onClick={onClick}>
                    {buttonText}
                </OKButton>
            </div>
        );
    }

    buildButtonsSection() {
        const cancelButton = this.props.cancelButton ? this.getCancelButton() : null;
        const nextButton = this.getNextButton();
        const previousButton = this.props.previousButton ? this.getPreviousButton() : null;

        return (
            <footer className="wizard-step__buttons">
                {cancelButton}
                {previousButton}
                {nextButton}
            </footer>
        );
    }

    buildPreLeaveModal() {
        const {
            onConfirmLeave,
            onPreLeaveModalReady,
            preleaveModalTitle,
            preleaveModalMessage,
            preleaveModalLeftButtonConfig,
            preleaveModalRightButtonConfig,
            showPreLeaveModal,
        } = this.props;

        if (showPreLeaveModal) {
            const acceptText = formatText('wizard-redirectConfirmationAcceptButton');
            const cancelText = formatText('wizard-redirectConfirmationCancelButton');
            const confirmationTitle = preleaveModalTitle ? preleaveModalTitle : formatText('wizard-redirectConfirmationTitle');
            const confirmationMessage = preleaveModalMessage ? preleaveModalMessage : formatText('wizard-redirectConfirmationMessage');

            return (
                <PreLeaveModalComponent
                    confirmationMessage={confirmationMessage}
                    confirmationTitle={confirmationTitle}
                    acceptText={acceptText}
                    cancelText={cancelText}
                    isReady={onPreLeaveModalReady}
                    leftButtonConfig={preleaveModalLeftButtonConfig}
                    rightButtonConfig={preleaveModalRightButtonConfig}
                    onConfirmLeave={onConfirmLeave}
                />
            );
        }
    }

    handleCancelClick() {
        const { actions } = this.props;

        actions.setWillCancel(true);

        if (actions.cancel) {
            actions.cancel();
            recordProcess(this.props.processType, PROC_CANCEL);
        }
    }

    render() {
        const { children, immPayrollLoan, taeTooltip, nodataKOxDTI } = this.props;
        const buttonsSection = this.buildButtonsSection();
        const preLeaveModal = this.buildPreLeaveModal();
        const tin = immPayrollLoan.get('tin');
        const tae = immPayrollLoan.get('tae');
        const arrangementFee = immPayrollLoan.get('arrangementFee');
        const currency = immPayrollLoan.getIn(['installment', 'currency']);
        const isFetching = immPayrollLoan.get('isFetching');
        const arrangementPercentage = immPayrollLoan.get('arrangementPercentage');
        const installment = immPayrollLoan.get('installment');
        return (
            <div className="col-xs-8 ok-section-box">
                <div className="col-xs-12">
                    {children}
                    <PayrollLoanCalculationCard
                        tin={tin}
                        tae={tae}
                        arrangementFee={arrangementFee}
                        currency={currency}
                        isFetching={isFetching}
                        arrangementPercentage={arrangementPercentage}
                        installment={installment}
                        immPayrollLoan={immPayrollLoan}
                        taeTooltip={taeTooltip}
                        nodata={nodataKOxDTI} />
                    {buttonsSection}
                    {preLeaveModal}
                </div>
            </div>
        );
    }
}

PayrollLoanLayoutWizard.propTypes = {
    actions: PropTypes.object.isRequired,
    cancelButton: PropTypes.bool,
    previousButton: PropTypes.bool,
    goBackButton: PropTypes.bool,
    children: PropTypes.element,
    confirmDescription: PropTypes.string,
    confirmTitle: PropTypes.string,
    finalButtonIcon: PropTypes.string,
    immFinalButton: PropTypes.string,
    isFetching: PropTypes.bool,
    isLoading: PropTypes.bool,
    nextButtonDisabled: PropTypes.bool,
    cancelButtonText: PropTypes.string,
    taeTooltip: PropTypes.object,
    immPayrollLoan: PropTypes.object.isRequired,
    processType: PropTypes.string,
    nodataKOxDTI: PropTypes.bool,
    onConfirmLeave: PropTypes.func,
    onPreLeaveModalReady: PropTypes.func,
    preleaveModalMessage: PropTypes.string,
    preleaveModalTitle: PropTypes.string,
    showPreLeaveModal: PropTypes.bool,
    preleaveModalLeftButtonConfig: PropTypes.shape({
        text: PropTypes.string,
        callback: PropTypes.func,
        redirect: PropTypes.bool
    }),
    preleaveModalRightButtonConfig: PropTypes.shape({
        text: PropTypes.string,
        callback: PropTypes.func,
        redirect: PropTypes.bool
    }),
};

PayrollLoanLayoutWizard.defaultProps = {
    onPreLeaveModalReady: () => {
        return false;
    },
    showPreLeaveModal: false
}

module.exports = PayrollLoanLayoutWizard;
